module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 4
// module chunks = 0